import ListComponent from './ListComponent'

const CareGivers = () => {
    return (
        <ListComponent type="caregiver" />
    )
}

export default CareGivers